export { default } from './NoteHeader';
